import ReactMarkdown from "react-markdown"

import { Flex, Popover, Tooltip } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { KaiSecondary } from "@/icons"
import { StatusKai } from "@/molecules/StatusKai"

import styles from "./FalsePositiveLabel.module.scss"

import type { FalsePositiveLabelProps } from "."

export const FalsePositiveLabel = (props: FalsePositiveLabelProps) => {
  const { isFalsePositive, description, title, children } = props
  const { t } = useTranslation("translation", { keyPrefix: "triage.drawer" })
  const { t: tKai } = useTranslation("translation", {
    keyPrefix: "triage.drawer.kai.sast"
  })
  let text = t(
    isFalsePositive ? "kai.sast.card.falsePositive" : "kai.sast.card.confirmed"
  )

  if (isFalsePositive === null) text = t("kai.sast.card.undetermined")

  const Component = description ? Popover : Tooltip

  return (
    <Component
      destroyOnHidden
      rootClassName={styles.root}
      title={
        title || (
          <Flex gap={8} align="center">
            <KaiSecondary className={styles.iconKai} />
            <span>
              {t("kai.customFix.whyFlagged", {
                value: text.toLocaleLowerCase()
              })}
            </span>
          </Flex>
        )
      }
      content={
        !!description && (
          <div className={styles.description}>
            <ReactMarkdown>{description}</ReactMarkdown>
          </div>
        )
      }
    >
      <Flex>
        <StatusKai isFalsePositive={isFalsePositive} t={tKai}>
          {children}
        </StatusKai>
      </Flex>
    </Component>
  )
}
